/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TGetNewsMainModel,
  IGetNewsMainRequest,
  IMappers,
  IGetNewsMainResponse,
  IGetNewsMainResponseError,
  TGetNewsMainResponse,
} from './types';

const defaultConfig: TGetNewsMainModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v1/get-news-main/',
  hostType: 'api',
} as TGetNewsMainModel;

function createGetNewsMainModel(parameters: IGetNewsMainRequest): TGetNewsMainModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewsMainOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewsMainRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewsMain<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewsMainOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetNewsMainResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetNewsMainModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewsMainResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewsMainResponseError);
    }
  }

  return { response, statusCode } as TGetNewsMainResponse;
}

export { defaultConfig, createGetNewsMainModel, fetchGetNewsMain };
